import { useMutation, useQueryClient } from '@gogame/query';

import {
  details,
  cancelationStorm,
} from 'scenes/Playground/data/queryKeyFactory';
import { updateCancelationStorm } from 'scenes/Playground/sources/playground';

const CANCELATION_STORM_PARAMS = {
  id: 11001,
  campaignId: 1360160,
};
export const useCancelationStorm = () => {
  const queryClient = useQueryClient();
  const updateCostModalMutation = useMutation(
    cancelationStorm(),
    updateCancelationStorm,
    {
      successMessage: () => 'Success Updated',
      refresh: false,
    }
  );

  const handleAction = async (params) => {
    await updateCostModalMutation.mutateAsync({
      ...CANCELATION_STORM_PARAMS,
      ...params,
    });
    queryClient.resetQueries({
      queryKey: details(params.id),
    });
  };

  return [handleAction, updateCostModalMutation];
};
